import React, { createContext, useContext, useEffect, useState } from 'react'

const GoToStatePro = createContext()

export const GoToState = ({ children }) => {
    const [benefit, setGoBenefit] = useState(null)
    const [post_id, setGoPostID] = useState(null)

    const setBenefit = (item) => {
        setGoBenefit(item)
    }
    const setPostID = (id) => {
        setGoPostID(id)
    }
    const value = {
        setBenefit,
        benefit,
        post_id,
        setPostID,
    }

    return <GoToStatePro.Provider value={value}>{children}</GoToStatePro.Provider>
}

export const getGoTo = () => {
    return useContext(GoToStatePro)
}
